import styled from "styled-components";

export const StyledAutoHeightTextArea = styled.div`
  width: 100%;
  position: relative;

  > textarea {
    resize: none;
    width: 100%;
    overflow-y: hidden; // 스크롤바 숨김
    height: 100%;
    padding: 0.8rem 0.8rem;
    outline: none;

    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.4rem;
    transition: all 0.2s ease;
    border: 0.1rem solid var(--bg-gray-2);
    font: var(--body-medium-400);

    &::placeholder {
      color: var(--text-gray-4);
    }

    color: var(--text-gray-4);

    background-color: var(--bg-gray-0);

    &:focus {
      color: var(--text-gray-strong);
      background-color: var(--bg-gray-normal);
      border: 0.1rem solid var(--bg-gray-2);
    }
  }

  .icon {
    position: absolute;
    width: 1.6rem;
    height: 1.6rem;
    flex-shrink: 0;
    top: 11px;
    right: 8px;
  }
`;
